export function parseGoogleMapsUrl(url: string): { lat: number; lng: number } | null {
  // /@lat,lng,zoom  e.g. maps.google.com/maps/@12.3456,78.9012,15z
  const atMatch = url.match(/@(-?\d+\.?\d*),(-?\d+\.?\d*)/);
  if (atMatch) return { lat: parseFloat(atMatch[1]), lng: parseFloat(atMatch[2]) };

  // ?q=lat,lng  or  ?ll=lat,lng
  const qMatch = url.match(/[?&](?:q|ll)=(-?\d+\.?\d*),(-?\d+\.?\d*)/);
  if (qMatch) return { lat: parseFloat(qMatch[1]), lng: parseFloat(qMatch[2]) };

  return null;
}

export function parseCoordString(data: string): { lat: string; lng: string; radius: string } {
  const parts = data.split(',').map((p) => p.trim());
  return {
    lat: parts[0] ?? '',
    lng: parts[1] ?? '',
    radius: parts[2] ?? '0',
  };
}

export function buildCoordString(lat: string, lng: string, radius: string): string {
  return `${lat}, ${lng}, ${radius || '0'}`;
}
